import type {DraftGuessModelV1} from '@albert-io/models';
import type {UseBoundStore, StoreApi} from 'zustand';
import type {SetStateWithImmer, QuestionType} from 'client/components/QuestionTypes/QuestionType.types';

export interface DraftInfo {
  draft: DraftGuessModelV1 | null;
  saveStatus: QuestionType.SaveStatus;
  editStartTime: Date | null;
}

export interface DraftGuessState {
  assignmentId: string | null;
  // storing draft guesses by question id
  draftByQuestionId: Record<string, DraftInfo>;
  draftGuessPromise: null | any;

  // going to access guess properties from instance directly instead of
  // storing guess values in the store itself

  // removed legacy store values
  // draftId
  // lastDraftTime
  // timeElapsed
  // pointsEarned
  // isGuessCorrect
}

export interface DraftGuessActions {
  // legacy draft actions
  hasDraftGuess: (questionId: string) => boolean;
  buildTimeElapsed: (questionId: string) => any; // time
  loadDraftGuess: (assignmentId: string | null, questionId: string) => DraftGuessModelV1;
  saveDraftGuess: (assignmentId: string | null, questionId: string, draftContent: any) => void;
  shouldNotSaveDraft: () => boolean;
  startTimer: (questionId: string) => void;
}

export const initialState: DraftGuessState = {
  assignmentId: null,
  draftByQuestionId: {}, // todo changes this to also store save statuses, edit start time draft guess promise maybe
  draftGuessPromise: null
};

export type DraftGuessStore = DraftGuessState & DraftGuessActions;

export type SetState = SetStateWithImmer<DraftGuessStore>;
export type GetState = UseBoundStore<StoreApi<DraftGuessStore>>['getState'];
